'use client'; // Error boundaries must be Client Components
/*******************************************************
* Global Error
*
* Last-resort error UI for errors thrown in the root layout. Replaces the root layout
* when active, so it renders its own <html>/<body> and does not use the app theme.
*
* Key Features:
* - Logs the error to Log_ClientErrors (source: boundary)
* - Retry re-renders the root layout
********************************************************/
//########## IMPORTS ##########
// #region IMPORTS
import { useEffect } from 'react';
import { logClientError } from '@/src/scripts/APIClient';
import { formatClientErrorText } from '@/src/scripts/libs/clientErrorLogging';
// #endregion


export default function GlobalError({
    error,
    retry,
}: {
    error: Error & { digest?: string }
    retry: () => void
}) {
    //########## MAIN LOGIC ##########
    // #region MAIN LOGIC
    useEffect(() => {
        logClientError(window.location.href, formatClientErrorText(error), {
            source: 'boundary',
            digest: error.digest ?? null,
        });
    }, [error]);
    // #endregion


    //########## MARKDOWN ##########
    // #region MARKDOWN
    return (
        <html lang="en">
            <body style={{ fontFamily: 'sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, paddingTop: 80 }}>
                <title>Something went wrong</title>
                <h2>Something went wrong</h2>
                <p>{error.message || 'An unexpected error occurred.'}</p>
                <button type="button" onClick={() => retry()}>Try again</button>
            </body>
        </html>
    );
    //#endregion
}
